/* eslint-disable import/no-anonymous-default-export */
import { SET_PRESENT_MODE } from '../actionConstants';

export default (state = false, action) => {
  switch (action.type) {
    case SET_PRESENT_MODE:
      return action.payload;
    default:
      return state;
  }
};
